let slideUp = (target, duration = 500) => {
  target.style.transitionProperty = 'height, margin, padding'
  target.style.transitionDuration = duration + 'ms'
  target.style.boxSizing = 'border-box'
  target.style.height = target.offsetHeight + 'px'
  target.offsetHeight
  target.style.overflow = 'hidden'
  target.style.height = 0
  target.style.paddingTop = 0
  target.style.paddingBottom = 0
  target.style.marginTop = 0
  target.style.marginBottom = 0
  window.setTimeout(() => {
    target.style.display = 'none'
    target.style.removeProperty('height')
    target.style.removeProperty('padding-top')
    target.style.removeProperty('padding-bottom')
    target.style.removeProperty('margin-top')
    target.style.removeProperty('margin-bottom')
    target.style.removeProperty('overflow')
    target.style.removeProperty('transition-duration')
    target.style.removeProperty('transition-property')
  }, duration)

  // On closing the Data Portability section, set the request type value back to an empty string
  if (target.getAttribute('id') === 'form-gdpr-data-account-request') {
    document.querySelector(
      '#form-gdpr-data-account-request-request-type'
    ).value = ''
  }
}

/* SLIDE DOWN */
let slideDown = (target, duration = 500) => {
  setTimeout(function () {
    target.style.removeProperty('display')
    let display = window.getComputedStyle(target).display
    if (display === 'none') display = 'block'

    target.style.display = display

    let height = target.offsetHeight

    target.style.overflow = 'hidden'
    target.style.height = 0
    target.style.paddingTop = 0
    target.style.paddingBottom = 0
    target.style.marginTop = 0
    target.style.marginBottom = 0
    target.offsetHeight
    target.style.boxSizing = 'border-box'
    target.style.transitionProperty = 'height, margin, padding'
    target.style.transitionDuration = duration + 'ms'
    target.style.height = height + 'px'

    target.style.removeProperty('padding-top')
    target.style.removeProperty('padding-bottom')
    target.style.removeProperty('margin-top')
    target.style.removeProperty('margin-bottom')

    window.setTimeout(() => {
      target.style.removeProperty('height')
      target.style.removeProperty('overflow')
      target.style.removeProperty('transition-duration')
      target.style.removeProperty('transition-property')
    }, duration)
  }, 200)
}

/* TOOGLE */
var slideToggle = (target, duration = 500) => {
  if (window.getComputedStyle(target).display === 'none') {
    return slideDown(target, duration)
  } else {
    return slideUp(target, duration)
  }
}

/* FADE */
var toggleFadeiSense = (elem, show) => {
  if (show) {
    elem.style.display = 'block'
    setTimeout(function () {
      elem.classList.add('show-isense')
      elem.classList.remove('hide-isense')
    }, 20)
  } else {
    elem.classList.remove('show-isense')
    elem.classList.add('hide-isense')
    setTimeout(() => {
      elem.style.display = 'none'
    }, 400)
  }
}

var email,
  type,
  consentGiven = false
var verificationModalContent =
  '<div id="data-verification-background"><div class="loading"></div><div id="data-verification-modal"><button class="data-verification-close" aria-label="Close">&times;</button><div id="data-verification-container"><input type="checkbox" aria-labelledby="gdpr-modal-container-text"><label id="data-verification-icon"><svg width="18px" height="18px" viewBox="0 0 18 18"><path d="M1,9 L1,3.5 C1,2 2,1 3.5,1 L14.5,1 C16,1 17,2 17,3.5 L17,14.5 C17,16 16,17 14.5,17 L3.5,17 C2,17 1,16 1,14.5 L1,9 Z"></path></path><polyline points="1 9 7 14 15 4"></polyline></svg></label><p id="gdpr-modal-container-text">I give my consent on collecting my email and IP address for the purpose of processing this request. For more check <a href="https://www.consentmo.com/privacy-policy-terms-of-service/en"  target="_blank" aria-label="Privacy Policy &amp Terms of Service link (opens in a new tab)">Privacy Policy &amp Terms of Service</a>.</p></div></div></div>'

var gdprSendRequest = function (callback) {
  fetch('https://www.cloudflare.com/cdn-cgi/trace', {
    method: 'GET',
    headers: {
      'Content-Type': 'text/plain',
    },
  })
    .then((resp) => resp.text())
    .then((resp) => {
      if (!resp.error) {
        let ipInfo = resp

        let formData = new FormData()

        formData.append('shop', Shopify.shop)
        formData.append('email', email)
        formData.append('type', type)
        formData.append('sourceOfRequest', 1)
        formData.append('ipAddress', ipInfo)
        formData.append('consentGiven', consentGiven)
        formData.append('page', 'gdpr')
        formData.append('lang', Shopify.locale ? Shopify.locale : '')
        formData.append(
          'gtranslateLang',
          isenseGDPR.Cookies.get('googtrans')
            ? isenseGDPR.Cookies.get('googtrans')
            : ''
        )

        fetch('https://gdpr.apps.isenselabs.com/gdprRequests/submitRequest', {
          method: 'POST',
          body: formData,
        })
          .then((resp) => resp.json())
          .then((resp) => {
            if (!resp.error) {

              if (resp.message.length) {
                alert(resp.message)
              } else {
                alert(
                  'Your request has been submitted successfully. Please check your email for more information.'
                )
              }
            } else {
              alert(resp.message)
            }
            if (typeof callback == 'function') {
              callback(resp)
            }
          })
          .catch((error) => {
            console.log(error)
            alert(error, error.message)
          })
      } else {
        alert(resp.message)
      }
    })
}

//Append modal to body, because otherwise it will not stay centered(even if position is fixed)
document
  .querySelector('body')
  .insertAdjacentHTML('beforeend', verificationModalContent)

document.addEventListener('DOMContentLoaded', function () {
  // When the user clicks on <span> (x), close the modal
  document
    .querySelector('.data-verification-close')
    .addEventListener('click', function (e) {
      e.preventDefault()
      closeVerificationModal()
    })

  document
    .querySelector('#data-verification-icon, #data-verification-container p')
    .addEventListener('click', function (e) {
      e.preventDefault()

      // Detect a href's click, because it is overwritten.
      if (e.target.tagName === 'A') {
        window.open(e.target.href, '_blank')
        return
      }

      document.querySelector('#data-verification-icon').classList.add('clicked')
      setTimeout(() => {
        toggleFadeiSense(
          document.querySelector('#data-verification-modal'),
          false
        )
        document.querySelector(
          '#data-verification-background .loading'
        ).style.display = 'inline-block'
        consentGiven = true
        gdprSendRequest(function (resp) {
          consentGiven = false
          closeVerificationModal()
        })
      }, 400)
    })
})

function openVerificationModal() {
  toggleFadeiSense(document.querySelector('#data-verification-modal'), true)
  toggleFadeiSense(
    document.querySelector('#data-verification-background'),
    true
  )
  document.querySelector('#data-verification-container input').focus()
}

function closeVerificationModal() {
  toggleFadeiSense(
    document.querySelector('#data-verification-background'),
    false
  )

  document.querySelector('#data-verification-icon').classList.remove('clicked')
  document.querySelector(
    '#data-verification-background .loading'
  ).style.display = 'none'
}

document
  .querySelector('#form-gdpr-edit-account-request-submit')
  .addEventListener('click', function (e) {
    e.preventDefault()
    email = document.querySelector(
      '#form-gdpr-edit-account-request-email'
    ).value
    type = 'customer/edit'
    openVerificationModal()
  })

document
  .querySelectorAll(
    '#btn-gdpr-requests-request, #btn-gdpr-personal-information-request, #btn-gdpr-orders-request'
  )
  .forEach((element) => {
    element.addEventListener('click', function (e) {
      e.preventDefault()
      type = ''

      switch (this.getAttribute('id')) {
        case 'btn-gdpr-requests-request':
          type = 'customer/requests'
          break
        case 'btn-gdpr-personal-information-request':
          type = 'customer/personal_info'
          break
        case 'btn-gdpr-orders-request':
          type = 'customer/orders'
          break
      }

      document.querySelector(
        '#form-gdpr-data-account-request-request-type'
      ).value = type
    })
  })

document
  .querySelector('#form-gdpr-data-account-request-submit')
  .addEventListener('click', function (e) {
    e.preventDefault()
    email = document.querySelector(
      '#form-gdpr-data-account-request-email'
    ).value
    type = document.querySelector(
      '#form-gdpr-data-account-request-request-type'
    ).value
    openVerificationModal()
  })

document
  .querySelector('#form-gdpr-personal-data-report-request-submit')
  .addEventListener('click', function (e) {
    e.preventDefault()
    email = document.querySelector(
      '#form-gdpr-personal-data-report-request-email'
    ).value
    type = 'customer/report'
    openVerificationModal()
  })

document
  .querySelector('#form-gdpr-delete-account-request-submit')
  .addEventListener('click', function (e) {
    e.preventDefault()
    email = document.querySelector(
      '#form-gdpr-delete-account-request-email'
    ).value
    type = 'customer/delete'
    openVerificationModal()
  })

// Keyboard navigation for the compliance page's requests
document.querySelector('#gdpr_page').addEventListener('keydown', function (e) {
  let isTabPressed = e.keyCode === 9 || e.key === 'Tab' || e.code === 'Tab'
  // This function saves us the trouble of calling e.preventDefault() after every focusing
  let executeFocus = (focusElement) => {
    focusElement.focus()
    e.preventDefault()
  }

  if (isTabPressed) {
    let gdprFormPickedLinkValue = document.querySelector(
      '#form-gdpr-data-account-request-request-type'
    ).value
    let gdprRequestsButton = document.querySelector(
      '#btn-gdpr-requests-request'
    )
    let personalInformationButton = document.querySelector(
      '#btn-gdpr-personal-information-request'
    )
    let ordersButton = document.querySelector('#btn-gdpr-orders-request')
    let personalDataReportButton = document.querySelector(
      '#btn-gdpr-personal-data-report-request'
    )
    let dataAccountFormEmailField = document.querySelector(
      '#form-gdpr-data-account-request-email'
    )
    let dataAccountFormSubmitButton = document.querySelector(
      '#form-gdpr-data-account-request-submit'
    )

    if (e.shiftKey) {
      if (
        (document.activeElement === personalInformationButton &&
          gdprFormPickedLinkValue === 'customer/requests') ||
        (document.activeElement === ordersButton &&
          gdprFormPickedLinkValue === 'customer/personal_info')
      ) {
        executeFocus(dataAccountFormSubmitButton)
      } else if (document.activeElement === dataAccountFormEmailField) {
        if (gdprFormPickedLinkValue === 'customer/requests') {
          executeFocus(gdprRequestsButton)
        } else if (gdprFormPickedLinkValue === 'customer/personal_info') {
          executeFocus(personalInformationButton)
        }
      } else if (document.activeElement === personalDataReportButton) {
        if (gdprFormPickedLinkValue !== 'customer/orders') {
          executeFocus(ordersButton)
        }
      }
    } else {
      if (
        (document.activeElement === gdprRequestsButton &&
          gdprFormPickedLinkValue === 'customer/requests') ||
        (document.activeElement === personalInformationButton &&
          gdprFormPickedLinkValue === 'customer/personal_info')
      ) {
        executeFocus(dataAccountFormEmailField)
      } else if (document.activeElement === dataAccountFormSubmitButton) {
        if (gdprFormPickedLinkValue === 'customer/requests') {
          executeFocus(personalInformationButton)
        } else if (gdprFormPickedLinkValue === 'customer/personal_info') {
          executeFocus(ordersButton)
        }
      } else if (document.activeElement === ordersButton) {
        if (gdprFormPickedLinkValue !== 'customer/orders') {
          executeFocus(personalDataReportButton)
        }
      }
    }
  }
})

// Keyboard navigation in data verification modal for accesibility
document
  .querySelector('#data-verification-modal')
  .addEventListener('keydown', function (e) {
    let isTabPressed = e.keyCode === 9 || e.key === 'Tab' || e.code === 'Tab'
    let isEscapePressed =
      e.keyCode === 27 || e.key === 'Escape' || e.code === 'Escape'
    let isSpacePressed =
      event.keyCode === 32 || e.key === ' ' || event.code === 'Space'
    let isEnterPressed =
      event.keyCode === 13 || e.key === 'Enter' || event.code === 'Enter'
    let dataVerificationCloseButton = document.querySelector(
      '.data-verification-close'
    )
    let dataVerificationCheckbox = document.querySelector(
      '#data-verification-container input'
    )
    let dataVerificationLink = document.querySelector(
      '#data-verification-container a'
    )
    // This function saves us the trouble of calling e.preventDefault() after every focusing
    let executeFocus = (focusElement) => {
      focusElement.focus()
      e.preventDefault()
    }

    if (isEscapePressed) {
      if (dataVerificationCloseButton) {
        dataVerificationCloseButton.click()
      }
    }

    if (isSpacePressed || isEnterPressed) {
      if (document.activeElement === dataVerificationCheckbox) {
        document
          .querySelector('#data-verification-container #data-verification-icon')
          .click()
      }
    }

    if (isSpacePressed || isEnterPressed) {
      let dataVerificationCheckbox = document.querySelector(
        '#data-verification-container input'
      )
      if (document.activeElement === dataVerificationCheckbox) {
        document
          .querySelector('#data-verification-container #data-verification-icon')
          .click()
      }
    }

    if (isTabPressed) {
      if (e.shiftKey) {
        if (
          dataVerificationCloseButton &&
          document.activeElement === dataVerificationCloseButton
        ) {
          executeFocus(dataVerificationLink)
        }
      } else {
        if (
          dataVerificationLink &&
          document.activeElement === dataVerificationLink
        ) {
          executeFocus(dataVerificationCloseButton)
        }
      }
    }
  })
